import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { DistributedGenerationSmallPage, DistributedGenerationSmallPageProps } from "./DistributedGenerationSmallPage";

export const EMPTY_PAGE_CONTENT: DistributedGenerationSmallPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/distributed-generation/10kw-or-less";

export const DistributedGenerationSmallPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<DistributedGenerationSmallPageProps>("distributed_generation___10kw_or_less", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <DistributedGenerationSmallPage {...routeProps} {...content} />;
};
